/* please refactor inline style */
/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, ScrollView } from 'react-native';
import { Divider } from 'react-native-elements';
import * as Yup from 'yup';
import Toast from 'react-native-toast-message';

import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';

import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { buttonFloating, buttonRounded } from '@/assets/styles/buttonStyles';

import ModalFull from '@components/modal/ModalFull';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaCard from '@components/sociolla/SociollaCard';
import {
  SociollaForm,
  SociollaInput,
  SociollaRadioButton,
  SociollaSubmitButton,
} from '@components/sociolla/form';

import { postLoyaltyCustomers } from '@api/ms-order';
import PropTypes from 'prop-types';

const propTypes = {
  testID: PropTypes.string,
  data: PropTypes.object,
  navigation: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  show: PropTypes.bool,
};

const validationSchema = Yup.object().shape({
  type: Yup.string()
    .required('Edit Point is required')
    .min(1, 'Edit Point is required')
    .label('Edit Point'),
  points: Yup.number()
    .required('Point Amount is required')
    .typeError('Limit Amount should number only')
    .min(1, 'Please add minimum 1 point')
    .label('Point Amount'),
  notes: Yup.string().required('Notes is required').label('Notes'),
});

const pointType = [
  {
    label: 'Add Point',
    value: 'add',
  },
  {
    label: 'Deduct Point',
    value: 'deduct',
  },
];

const ModalLoyalty = (props) => {
  const dispatch = useDispatch();
  const needApproval = useSelector((state) =>
    Boolean(
      [
        'sales_supervisor',
        'branch_head',
        'regional_manager',
        'regional_support',
        'key_account_manager',
        'group_key_account_manager',
        'national_key_account_manager',
        'distributor_manager',
        'regional_distributor_manager',
      ].indexOf(state.auth.user?.role?.code || '') > -1,
    ),
  );

  const submit = (data, resetForm) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    const payload = {
      customer: {
        id: props.data.id,
        name: props.data.name,
      },
      notes: data.notes,
      points: data.type === 'deduct' ? data.points * -1 : data.points,
    };
    postLoyaltyCustomers(payload)
      .then((response) => {
        if (needApproval) {
          dispatch(
            showAlert({
              show: true,
              title: 'Edit Loyalty Point Submitted',
              description:
                'Edit loyalty point submitted, you’ll be notified once it is approved.',
              isConfirm: false,
              onCallback: () => {
                props.navigation.navigate('CustomerNavigator');
              },
            }),
          );
        }
        resetForm();
        props.onSubmit();
      })
      .catch((error) => {
        if (error?.response?.status == 400 && error?.response?.data?.message) {
          Toast.show({ text1: error.response.data.message, type: 'error' });
        } else {
          Toast.show({
            text1: 'Something Wrong, please try again.',
            type: 'error',
          });
        }
        dispatch(showPopup({ name: 'isLoading', value: false }));
      });
  };

  const handleSubmit = (data, { resetForm }) => {
    if (needApproval) {
      submit(data, resetForm);
      return;
    }
    const title = data.type === 'deduct' ? 'Deduct Point' : 'Add Point';
    const label = data.type === 'deduct' ? 'deducted' : 'added';
    dispatch(
      showAlert({
        show: true,
        title,
        description: `Customers loyalty point will be ${label}. Do you want to proced?`,
        onCallback: (val) => submit(data, resetForm),
      }),
    );
  };

  return (
    <ModalFull
      testID={props.testID}
      show={props.show}
      title="Edit Point"
      onClose={props.onClose}>
      <ScrollView style={{ paddingVertical: 15, paddingHorizontal: 25 }}>
        <SociollaText
          type="medium"
          style={{ fontSize: 18, color: Colors.black1 }}>
          {props.data.name}
        </SociollaText>
        <SociollaCard
          testID="modal-loyalty-current-point-card"
          title={'Current Loyalty Point'}
          borderColor={false}
          titleStyle={{ fontSize: 14, color: Colors.black5 }}
          style={{
            minHeight: 80,
            maxWidth: 200,
            borderTopWidth: 0,
            backgroundColor: Colors.blue9,
            flex: 1,
            marginVertical: 10,
          }}>
          <SociollaText
            type="medium"
            style={{
              fontSize: 18,
              color: Colors.black3,
              position: 'absolute',
              bottom: 10,
              left: 16,
            }}
            currency={true}>
            {props.data.point}
          </SociollaText>
        </SociollaCard>
        <Divider
          style={{
            borderBottomWidth: 1,
            borderBottomColor: Colors.grey9,
            marginBottom: 20,
            marginTop: 10,
          }}
        />
        <SociollaForm
          initialValues={{
            type: '',
            points: '',
            notes: '',
          }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}>
          <View style={{ marginBottom: 10 }}>
            <SociollaRadioButton
              testID="modal-loyalty-type-radio"
              name="type"
              label="Edit Point"
              data={pointType}
            />
          </View>
          <View style={{ marginBottom: 10 }}>
            <SociollaInput
              testID="modal-loyalty-points-input"
              keyboardType="numeric"
              name="points"
              label="Point Amount"
            />
          </View>
          <SociollaInput
            testID="modal-loyalty-notes-input"
            name="notes"
            label="Notes"
            multiline={true}
            numberOfLines={4}
            inputContainerStyle={{ height: 'auto' }}
          />
          <View
            style={[
              isWeb ? { marginTop: 20, flex: 1 } : buttonFloating,
              isWeb
                ? { justifyContent: 'center' }
                : { position: 'relative', elevation: 0, marginTop: 20 },
              { width: '100%', bottom: 0 },
            ]}>
            <SociollaSubmitButton
              testID="modal-loyalty-submit-btn"
              buttonStyle={{ ...buttonRounded, width: '100%' }}
              title={
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: 14,
                    letterSpacing: 0.5,
                    color: Colors.white,
                    width: '100%',
                    textAlign: 'center',
                  }}>
                  Submit
                </SociollaText>
              }
            />
          </View>
        </SociollaForm>
      </ScrollView>
    </ModalFull>
  );
};

ModalLoyalty.propTypes = propTypes;
// const styles = StyleSheet.create({});

export default ModalLoyalty;
